import data from "../../shared/sharedData";

export default {
  // modalPrefill: {
  //   type: "agriculture",
  //   machine_name: "eta_790a_addendum_b_employment",
  //   modal_name: "addProfilesModal",
  //   title: "Agricultural Business Profiles",
  //   description:
  //     "Select the Agricultural Business profile(s) to populate in the Addendum B table.",
  //   isVisible: {
  //     when: "eta_790a_c7_is_work_addendum_b_completed",
  //     is: "YES",
  //   },
  // },
  name: "Addendum B - Additional Agricultural Business and Place of Employment Information",
  pageInfo: {
    text: `
    <strong>Additional Agricultural Business Information</strong>
    <br>
    Addendum B, Section C.1, will collect up to three (3) rows of information related to the agricultural businesses employing workers or receiving labor or services.  For electronic filings, if the employer needs to disclose information related to more than 3 agricultural businesses, the filing system will automatically provide the employer with the option of adding more rows to Section C.1 of the Addendum B until the response is completed.  For mailed or paper filings, the employer will make one or more copies of Section C.1 of the Addendum B to complete and attach to the Form ETA-790A.
    <br>
    <br>
    <strong>Additional Place of Employment Information</strong>
    <br>
    This Addendum must be fully completed and submitted with the Form ETA-790A when the work performed under this agricultural clearance order necessitates disclosure of an anticipated schedule of work at different places of employment, as defined by 20 CFR 655.103.  For each place of employment, the employer must complete all required and conditionally required information in Columns 1 through 5.  Addendum B, Section C.2, will collect up to five (5) rows of information related to the place(s) of employment where workers will perform work under this agricultural clearance order.  For electronic filings, if the employer needs to disclose more than five (5) rows of additional places of employment, the filing system will automatically provide the employer with the option of adding more rows to Section C.2 of the Addendum B until the response is completed.  For mailed or paper filings, the employer will make one or more copies of Section C.2 of the Addendum B to complete and attach to the Form ETA-790A.
`,

    coloring: "grey",
    isVisible: {
      when: "eta_790a_c7_is_work_addendum_b_completed prelim_2_employer_type prelim_2_employer_type prelim_3_is_contractor eta_790_b1_poc_name eta_790_b15_poc_fein",
      is: "YES joint association-joint YES !undefined !undefined",
      operator: "compareMultiFieldValuesOR_ISArray",
    },
  },
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        title: "Information Required",
        type: "info",
        groupedAlerts: [
          {
            description: `
              Please specify in <strong>Field C.7</strong> whether work will be  performed at multiple worksites.
            `,
            isVisible: {
              when: "eta_790a_c7_is_work_addendum_b_completed",
              is: "untouched",
              operator: "untouched",
            },
          },
          {
            description: `
              Please enter in <strong>Field II.1. Legal Business Name</strong> under Job Cover Sheet.
            `,
            isVisible: {
              when: "eta_790_b1_poc_name",
              is: "untouched",
              operator: "untouched",
            },
          },
          {
            description: `
              Please enter in <strong>Field II.15 Federal Employer Identification Number</strong> under Job Cover Sheet.
            `,
            isVisible: {
              when: "eta_790_b15_poc_fein",
              is: "untouched",
              operator: "untouched",
            },
          },
        ],
        isVisible: {
          when: "eta_790a_c7_is_work_addendum_b_completed eta_790_b1_poc_name eta_790_b15_poc_fein",
          is: "undefined undefined undefined",
          operator: "compareMultiFieldValuesOR_ISArray",
        },
      },
      {
        title: "Section Complete",
        description:
          "Because you indicated that work will only be performed at one worksite (per Section C), no Addendum B is necessary for this application.",
        type: "success",
        isVisible: {
          when: "eta_790a_c7_is_work_addendum_b_completed prelim_2_employer_type prelim_3_is_contractor",
          is: [
            ["N/A"],
            ["individual", "association-sole", "association-agent"],
            ["NO"],
          ],
          operator: "compareMultiFieldValuesAND_ORInArray",
        },
      },
    ],
  },
  sections: [
    {
      code: "Addendum B (C.1)",
      name: "Additional Agricultural Business Information",
      machine_name: "agBusinesses",
      isVisible: {
        when: "eta_790a_c7_is_work_addendum_b_completed prelim_2_employer_type prelim_2_employer_type prelim_3_is_contractor eta_790_b1_poc_name eta_790_b15_poc_fein",
        is: "YES joint association-joint YES !undefined !undefined",
        operator: "compareMultiFieldValuesOR_ISArray",
      },
      validate: [
        {
          tableRequiredIf: [
            "eta_790a_c7_is_work_addendum_b_completed",
            "eta_790a_addendum_b_employment",
          ],
          message: "Please enter a row for either Addendum B (C.1) or (C.2)",
          needsFieldValues: true,
          extraData: {
            operator: "&&",
            valueOf: ["YES", undefined],
          },
        },
        "tableIncomplete",
      ],
      isModal: true,
      openModalHeader: "Add Addendum B (C.1)",
      modalHeader: "Add Additional Agricultural Business Information",
      listType: "table",
      showPagination: true,
      removeFromFieldArray: true,
      master_fieldArray: "agBusinesses",
      keepSortOnModalEdit: true,
      isLinkage: true,
      modalFields: [
        {
          machine_name: "business_id",
          label: "Business Id",
          widget: "table_linkage",
          hidden: true,
          hideOnTable: true,
          linkages: {
            type: "createLinkageId",
            fromFieldArray: "agBusinesses",
            toFieldArray: "eta_790a_addendum_b_employment",
            fieldsToModify: [
              { set: "agricFeinId", from: "agricFein" },
              { set: "legalName", from: "agricLegalName" },
            ],
            removeRow: true,
            toLinkageIdFieldName: "business_id",
            linkageIdPrefix: "B",
            removalTableColumn: "Removal790AColumns",
          },
        },
        {
          machine_name: "agricFein",
          widget: "text",
          code: "1.",
          label: "FEIN (from IRS)",
          validate: [
            "required",
            "fein",
            { minLength: 10, message: "This is not a valid FEIN" },
            {
              uniqueValueCheck: {
                fieldsToCheck: [
                  {
                    fieldToCheck: "eta_790_b15_poc_fein",
                  },
                  {
                    fieldArray: "agBusinesses",
                    fieldToCheck: "agricFein",
                  },
                ],
              },
              message:
                "No duplicate FEINs are allowed. Please enter a unique FEIN.",
              needsFieldValues: true,
            },
          ],
          parse: "fein",
          maxLength: 10,
          tooltip: `Enter the nine-digit Federal Employer Identification Number (FEIN) assigned by the IRS.  <u>Do not enter a social security number</u>.  The entry in this field must be the same as the entry in Section B, Item 12 of the Form ETA-9142A.  <em>Important Note</em>: All employers, <u>including private households</u>, MUST obtain an FEIN from the IRS before completing this application.  Information on obtaining an FEIN can be found at <a href="https://www.IRS.gov" rel="noopener noreferrer" target="_blank"><u>www.IRS.gov</u></a>.`,
        },
        {
          machine_name: "agricLegalName",
          label: "Legal Business Name",
          code: "2.",
          widget: "text",
          validate: [
            "required",
            {
              minLength: 2,
              message: "Legal Business Name must contain at least 2 characters",
            },
            {
              uniqueValueCheck: {
                fieldsToCheck: [
                  {
                    fieldToCheck: "eta_790_b1_poc_name",
                  },
                  {
                    fieldArray: "agBusinesses",
                    fieldToCheck: "agricLegalName",
                  },
                ],
              },
              message:
                "No duplicate business names are allowed. Please enter a unique business name.",
              needsFieldValues: true,
            },
          ],
          maxLength: 120,
          tooltip: `Enter the full legal name of the business, person, association, firm, corporation, or organization, <em>i.e.</em>, the employer filing this application.  The employer’s full legal name is the exact name of the individual, corporation, LLC, partnership, or other organization that is reported to the Internal Revenue Service (IRS).`,
        },
        {
          machine_name: "agricTotalWorkers",
          code: "3.",
          widget: "text",
          label: "Total Workers",
          tooltip: `Enter the total number of workers needed to be employed to perform the temporary agricultural services or labor for this agricultural business.  The total number of workers includes (1) the number of former non-H-2A employees the employer anticipates will return—both those workers who can and who cannot reasonably return to their residence within the same day; and (2) the number of additional workers the employer seeks to recruit through this H-2A clearance order and other H-2A program recruitment.`,
          validate: [
            "required",
            {
              minValue: 0,
              message:
                "Workers needed must be equal to or greater than zero, and also be a whole number.",
            },
            {
              valueChecker: "agricTotalWorkers",
              message: "Please fill out A.2A and A.2B.",
              needsFieldValues: true,
              extraData: {
                valueOf: "eta_790a_a2a_workers_needed_total",
                check: "ifValueEmpty",
                prefix: "add_values_field",
                modal: true,
              },
            },
            {
              fieldComparison: "agricTotalWorkers",
              message:
                "This number should be less than or equal to the total workers needed",
              needsFieldValues: true,
              extraData: {
                operator: "<=",
                valueOf: "eta_790a_a2a_workers_needed_total",
                prefix: "add_values_field",
                modal: true,
              },
            },
          ],
          parse: "positiveWholeNumber",
          maxLength: 4,
        },
        {
          machine_name: "agricTradeName",
          code: "4.",
          widget: "text",
          label: "Trade Name/Doing Business As (DBA), if applicable §",
          hideOnTable: true,
          validate: [
            {
              minLength: 5,
              message:
                "Trade Name/Doing Business As (DBA) must contain at least 5 characters",
            },
          ],
          maxLength: 120,
          tooltip: `Enter the full trade name or “Doing Business As” (DBA) name, if applicable, of the business, person, association, firm, corporation, or organization (i.e., the employer filing this application).  Do not include “DBA” in front of the full trade name entered or after the full legal name entered in Item 2.`,
        },
        {
          machine_name: "agricPrevTradeName1",
          hideOnTable: true,
          widget: "text",
          code: "5.",
          label: "Previous DBA, if applicable §",
          validate: [
            {
              minLength: 5,
              message: "Previous DBA must contain at least 5 characters",
            },
          ],
          maxLength: 120,
          tooltip: `Enter the employer’s previous full trade name or DBA name, if applicable, of the business, person, association, firm, corporation, or organization used three years prior to the filing of this application.  Do not include “DBA” in front of the full trade name.  If the employer has additional DBAs used, prior to the filing of this application, insert additional names in Item 6.`,
        },
        {
          machine_name: "agricPrevTradeName2",
          hideOnTable: true,
          widget: "text",
          code: "6.",
          label: "Previous DBA, if applicable §",
          validate: [
            {
              minLength: 5,
              message: "Previous DBA must contain at least 5 characters",
            },
          ],
          maxLength: 120,
          tooltip: `Enter the employer’s previous full trade name(s) or DBA name(s), if applicable, of the business, person, association, firm, corporation, or organization used three years prior to the filing of this application.  Do not include “DBA” in front of the full trade name(s).`,
        },
        {
          hideOnTable: true,
          machine_name: "agricAddress1",
          code: "7.",
          label: "Address 1",
          widget: "text",
          validate: [
            "required",
            {
              minLength: 5,
              message: "Address 1 must contain at least 5 characters.",
            },
          ],
          maxLength: 120,
          tooltip: `Enter the street address of the location of the business.  The business location address must be a physical location and cannot be a P.O. box.  Use commonly understood street or highway numbers and names to identify the place of business.  For a rural or other geographic location without a street address, enter “NONE” and then provide as much information as possible using Items 9 through 12.  `,
          info: {
            text: "Enter the business street address of the employer’s point of contact. A P.O. Box is a mailing address and not a valid physical address location and, when disclosed on this application, the CO will issue a NOD requesting removal of the P.O. Box mailing address and provide the employer with an opportunity to amend the application with a valid physical address location.",
            coloring: "grey",
            divider: false,
            css: {
              marginTop: 20,
              marginBottom: 10,
            },
          },
        },
        {
          hideOnTable: true,
          machine_name: "agricAddress2",
          code: "8.",
          label: "Address 2 <em>(suite floor and number)</em> §",
          widget: "text",
          validate: [
            {
              minLength: 5,
              message: "Address 2 must contain at least 5 characters.",
            },
          ],
          maxLength: 120,
          tooltip: `If additional space is needed for the street address, use this line to complete the employer’s street address.  If no additional space if needed, enter “N/A”.`,
        },
        {
          hideOnTable: true,
          machine_name: "agricCity",
          code: "9.",
          label: "City",
          widget: "text",
          maxLength: 35,
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters",
            },
          ],
          tooltip: `Enter the city or town in which the place of business is located.`,
        },
        {
          machine_name: "agricState",
          code: "10.",
          label: "State",
          widget: "select",
          selection: data.state,
          state: true,
          validate: ["required"],
          tooltip: `Enter the State/District/Territory in which the place of business is located.`,
        },
        {
          hideOnTable: true,
          machine_name: "agricPostalCode",
          code: "11.",
          label: "Postal Code",
          widget: "text",
          maxLength: 10,
          validate: ["required", "postal"],
          message: "This field cannot be more than 10 characters long.",
          tooltip: `Enter the postal (zip) code in which the place of business is located.`,
        },
        {
          machine_name: "agricCounty",
          code: "12.",
          label: "County",
          widget: "countyselect",
          disabled: true,
          parent_machine_name: "add_values_field",
          disableWhenField: "agricState",
          validate: [
            "required",
            {
              required_county: "agricState",
              message: "add_values_field",
              needsFieldValues: true,
            },
          ],
          tooltip: `Enter the county in which the place of business is located.`,
        },
      ],
    },
    {
      code: "Addendum B (C.2)",
      name: "Additional Place of Employment Information",
      machine_name: "eta_790a_addendum_b_employment",
      isModal: true,
      removeFromFieldArray: true,
      openModalHeader: "Add Addendum B (C.2)",
      fullscreenModal: true,
      modalHeader: "Add Additional Place of Employment Information",
      listType: "table",
      showPagination: true,
      isVisible: {
        when: "eta_790a_c7_is_work_addendum_b_completed prelim_2_employer_type prelim_2_employer_type prelim_3_is_contractor eta_790_b1_poc_name eta_790_b15_poc_fein",
        is: "YES joint association-joint YES !undefined !undefined",
        operator: "compareMultiFieldValuesOR_ISArray",
      },
      validate: [
        {
          tableRequiredIf: [
            "eta_790a_c7_is_work_addendum_b_completed",
            "agBusinesses",
          ],
          message: "Please enter a row for either Addendum B (C.1) or (C.2)",
          needsFieldValues: true,
          extraData: {
            operator: "&&",
            valueOf: ["YES", undefined],
          },
        },
        "tableIncomplete",
      ],
      keepSortOnModalEdit: true,
      editButton: true,
      removeLink: "Remove Additional Place of Employment",
      master_fieldArray: "eta_790a_addendum_b_employment",
      modalFields: [
        {
          machine_name: "legalName",
          code: "1.",
          label: "Legal Business Name",
          isInlineModal: true,
          widget: "table_linkage",
          linkages: {
            linkageIdPrefix: "B",
            type: "linkageSelectInput",
            countyField: "employment_county_id", // To address county prefill issues with state changes
            dynamicUpdatesBySelection: [
              {
                setOptionFromField: "eta_790_b1_poc_name",
                dynamicUpdates: [
                  {
                    set: "agricFeinId",
                    from: "eta_790_b15_poc_fein",
                  },
                  {
                    set: "business_id",
                    to: "B0",
                  },
                ],
              },
              {
                setOptionFromFieldArray: "agBusinesses",
                setOptionFromField: "agricLegalName",
                dynamicUpdates: [
                  { set: "agricFeinId", from: "agricFein" },
                  { set: "business_id", from: "business_id" },
                ],
              },
            ],
          },
          validate: ["required", { minLength: 2 }],
          maxLength: 120,
          tooltip: `Enter the full legal name of the business who owns or operates the place of employment identified in either the Form ETA-790, Section II, or Section C.1 of the Addendum B.  In circumstances where the same business owns or operates multiple places of employment where work will be performed, the same full legal name may be used in multiple rows.`,
        },
        {
          hideOnTable: true,
          widget: "generic_prefill_button",
          label:
            "Click to prefill address from the selected Agricultural Business",
          text: "Prefill Address From Selected",
          countyField: "employment_county_id",
          isInlineModal: true,
          isVisible: {
            when: "legalName",
            is: ["- Select -", undefined, null, ""],
            prefix: "add_values_field",
            operator: "!==",
          },
          onClick: (formApi) => {
            const formValues = formApi.getState().values;
            const modalValues = formValues?.add_values_field?.[0];

            let fieldMapping = {
              agricAddress1: "employment_address_1",
              agricCity: "employment_city",
              agricState: "employment_state_id",
              agricPostalCode: "employment_zip",
              agricCounty: "employment_county_id",
            };

            // Map Emp Poc fields into array
            const empPocData = {
              agricFein: formValues?.eta_790_b15_poc_fein,
              agricAddress1: formValues?.eta_790_b7_poc_address_1,
              agricCity: formValues?.eta_790_b9_poc_city,
              agricState: formValues?.eta_790_b10_poc_state_id,
              agricPostalCode: formValues?.eta_790_b11_poc_zip,
              agricCounty: null, // No county field for Emp Poc
            };

            // Addendum B (C.1) array
            const agBusArrayData = formValues?.agBusinesses || [];

            // Find the dataset to prefill
            const foundDataset = [empPocData, ...agBusArrayData].find(
              (info) => info?.agricFein === modalValues?.agricFeinId
            );

            if (!!foundDataset) {
              Object.keys(foundDataset).forEach((fieldName) => {
                const mappedFieldName = fieldMapping?.[fieldName];
                if (!!mappedFieldName) {
                  modalValues[mappedFieldName] = foundDataset?.[fieldName];
                }
              });
            }
            formApi.change("add_values_field", [modalValues]);

            // Optional return for values for county prefill
            return modalValues;
          },
        },

        {
          machine_name: "business_id",
          widget: "text",
          disabled: true,
          hidden: true,
          hideOnTable: true,
        },
        {
          machine_name: "agricFeinId",
          label: "FEIN",
          widget: "text",
          disabled: true,
          isInlineModal: true,
        },
        {
          hideOnTable: true,
          machine_name: "employment_address_1",
          code: "2.a",
          label: "Address Location",
          widget: "text",
          validate: ["required", { minLength: 5 }],
          info: {
            text: "Enter the business street address of the employer’s point of contact. A P.O. Box is a mailing address and not a valid physical address location and, when disclosed on this application, the CO will issue a NOD requesting removal of the P.O. Box mailing address and provide the employer with an opportunity to amend the application with a valid physical address location.",
            coloring: "grey",
            divider: false,
            css: {
              marginTop: 20,
              marginBottom: 10,
            },
          },
          maxLength: 120,
          tooltip: `Enter the street address of the location where work will be performed.  The place of employment address must be a physical location and cannot be a P.O. box.  Use commonly understood street or highway numbers and names to identify the place of employment.  For a rural or other geographic location without a street address, enter “NONE” and then provide as much information in Items C.2b through C.2e as possible, supplemented with additional information in Column 3. `,
        },
        {
          hideOnTable: true,
          machine_name: "employment_city",
          code: "2.b",
          label: "City",
          widget: "text",
          validate: ["required", { minLength: 2 }],
          maxLength: 35,
          tooltip: `Enter the city or town in which the place of employment is located.`,
        },
        {
          machine_name: "employment_state_id",
          code: "2.c",
          label: "State",
          widget: "select",
          selection: data.state,
          state: true,
          validate: ["required"],
          tooltip: `Enter the State/District/Territory in which the place of employment is located.`,
        },
        {
          hideOnTable: true,
          machine_name: "employment_zip",
          widget: "text",
          code: "2.d",
          label: "Postal Code",
          validate: ["required", "postal"],
          maxLength: 10,
          message: "This field cannot be more than 10 characters long.",
          tooltip: `Enter the postal (zip) code in which the place of employment is located.`,
        },
        {
          machine_name: "employment_county_id",
          widget: "countyselect",
          code: "2.e",
          label: "County",
          disabled: true,
          parent_machine_name: "add_values_field",
          disableWhenField: "employment_state_id",
          required: true,
          validate: [
            "required",
            {
              required_county: "employment_state_id",
              message: "add_values_field",
              needsFieldValues: true,
            },
          ],
          tooltip: `Enter the county in which the place of employment is located.`,
        },
        {
          hideOnTable: true,
          machine_name: "additional_info",
          code: "3.a",
          label: "Additional Place of Employment Information",
          widget: "text_area",
          rows: 5,
          inputLimit: 500,
          // validate: ["required"],
          tooltip: `
            First, enter any additional information about the place of employment location.  Examples may include more specific information about the fields where work will be performed in close proximity to the address location, more specific directions on how workers can reach the place of employment, and/or Global Positioning System (GPS) coordinates, especially in very rural and isolated geographic areas.  If no additional information concerning the place of employment is needed, <strong>LEAVE BLANK</strong>.
            `,
        },
        {
          hideOnTable: true,
          isGroup: {
            machine_name: "isAdditionalActivity",
            code: "3.b",
            label:
              "Are ALL activities from the ETA-790A “Job Duties” (Section A, #8a) being performed at this worksite location?",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
                setSchema: [
                  {
                    set: "add_values_field.[0].additionalActivity",
                    to: "All Job Duties specified on the 790A Job Order (Section A, #8a) are being performed at this worksite.",
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                setSchema: [
                  {
                    set: "add_values_field.[0].additionalActivity",
                    to: "",
                  },
                ],
              },
            ],
          },
        },
        {
          machine_name: "additionalActivity",
          label:
            "Describe what specific services or labor is to be performed at this worksite.",
          hideOnTable: true,
          widget: "text_area",
          inputLimit: 500,
          validate: ["required"],
          isVisible: {
            when: "isAdditionalActivity",
            is: "NO",
            prefix: "add_values_field",
          },
        },
        {
          machine_name: "additionalActivity",
          label:
            "Describe what specific services or labor is to be performed at this worksite.",
          hideOnTable: true,
          inputLimit: 500,
          widget: "text_area",
          validate: ["required"],
          disabled: true,
          isVisible: {
            when: "isAdditionalActivity",
            is: "YES",
            prefix: "add_values_field",
          },
        },
        {
          machine_name: "crop_ids",
          code: "3.c",
          label: "Crop and Agricultural Activity",
          widget: "table_linkage",
          tableInfoHeader:
            "Please indicate which agricultural activities disclosed on the Addendum A are being performed at this worksite location.",
          removeFromFieldArray: true,
          master_fieldArray: "eta_790a_addendum_b_employment",
          editLinkageTable: true,
          tooltip:
            "Second, enter the “Crop or Agricultural Activity” identified on the Addendum A, Column 2, to disclose all of the crop(s) or agricultural activity(ies) and, if applicable, distinct work task(s) performed within that crop or agricultural activity that will be performed by workers at the place of employment.  The “Crop or Agricultural Activity” assigned to a crop or agricultural activity may be used in multiple rows in circumstances, for instance, where the employer associated with the “Legal Business Name” identified in Column 1 will have a need for workers to the same work at different places of employment it owns or operates.",
          linkages: {
            fromFieldArray: "eta_790a_addendum_a",
            toFieldArray: "eta_790a_addendum_b_employment",
            selectionTableColumn: "Selection790AAddendumBColumns",
            viewTableColumn: "View790AAddendumBColumns",
            idFieldName: "crop_id",
            descriptionFieldName: "crop_name",
            linkageIdPrefix: "A",
            type: "linkageTable",
            itemUIName: "Crops",
          },
          warning: {
            text: "Enter Addendum A to import Crops/Agricultural Activity data.",
          },
        },
        {
          hideOnTable: true,
          machine_name: "begin_date",
          widget: "date",
          code: "4.",
          label: "Begin Date §",
          minDate: "eta_790a_a3_begin_date",
          maxDate: "eta_790a_a4_end_date",
          tooltip: `Enter the begin date for the period of intended employment at this place of employment.  Use a month/day/year (<em>mm/dd/yyyy</em>) format.`,
          isVisible: {
            when: "prelim_5_is_livestock appIsItinerant prelim_2_employer_type",
            is: "YES YES association-joint",
            operator: "compareMultiFieldValuesOR_ISArray",
          },
          prefillFromField: "eta_790a_a3_begin_date",
          validate: [
            "required",
            {
              valueChecker: "begin_date",
              message: "Please fill out A.3 First Date.",
              needsFieldValues: true,
              extraData: {
                valueOf: "eta_790a_a3_begin_date",
                check: "ifValueEmpty",
                prefix: "add_values_field",
                modal: true,
              },
            },
            {
              dateStartEnd: "end_date",
              message: "First Date cannot be after Last Date.",
              needsFieldValues: true,
              extraData: {
                prefix: "add_values_field",
                type: "start",
                currentField: "begin_date",
                isModal: true,
              },
            },
            {
              dateRangeCheck: "begin_date",
              message:
                "Start Date must occur on or within the date range set in A.3 and A.4 in Section A of this job order.",
              needsFieldValues: true,
              extraData: {
                prefix: "add_values_field",
                begin_date: "eta_790a_a3_begin_date",
                end_date: "eta_790a_a4_end_date",
                isModal: true,
              },
            },
          ],
        },
        {
          hideOnTable: true,
          machine_name: "end_date",
          widget: "date",
          code: "5.",
          label: "End Date §",
          minDate: "eta_790a_a3_begin_date",
          maxDate: "eta_790a_a4_end_date",
          tooltip: `Enter the end date for the period of intended employment at this place of employment.  Use a month/day/year (<em>mm/dd/yyyy</em>) format.`,
          prefillFromField: "eta_790a_a4_end_date",
          isVisible: {
            when: "prelim_5_is_livestock appIsItinerant prelim_2_employer_type",
            is: "YES YES association-joint",
            operator: "compareMultiFieldValuesOR_ISArray",
          },
          validate: [
            "required",
            {
              valueChecker: "end_date",
              message: "Please fill out A.4 Last Date.",
              needsFieldValues: true,
              extraData: {
                valueOf: "eta_790a_a4_end_date",
                check: "ifValueEmpty",
                prefix: "add_values_field",
                modal: true,
              },
            },
            {
              dateStartEnd: "begin_date",
              message: "Last Date cannot be before First Date",
              needsFieldValues: true,
              extraData: {
                prefix: "add_values_field",
                type: "end",
                currentField: "end_date",
                isModal: true,
              },
            },
            {
              dateRangeCheck: "end_date",
              message:
                "Last Date must occur on or within the date range set in A.3 and A.4 in Section A of this job order.",
              needsFieldValues: true,
              extraData: {
                prefix: "add_values_field",
                begin_date: "eta_790a_a3_begin_date",
                end_date: "eta_790a_a4_end_date",
                isModal: true,
              },
            },
          ],
        },
      ],
      label:
        "Use the table below to enter the details about  each additional place of employment, when applicable.",
    },
  ],
};
